import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { DataService } from "../../../../shared/session/index";
import { SessionInfo } from "../../../../shared/session/SessionInfo";
import { Iapplication } from './../shared/aplicacion.model';

@Injectable({
  providedIn: 'root',
})
export class AplicacionService {
  constructor(private dataService: DataService, private sessionInfo: SessionInfo) { }

  private insertarApplicationUrl: string = 'Aplicacion/Insertar';
  private actualizarApplicationUrl: string = 'Aplicacion/Actualizar';
  private obtenerApplicationUrl: string = 'Aplicacion/Obtener';
  private listarApplicationUrl: string = 'Aplicacion/Listar';
  private listarPorApplicationUrl: string = 'Aplicacion/ListarPor';
  private listarApplicationAccessUrl: string = 'Aplicacion/listarAccess'
  private listarApplicationPorOfficeUrl: string = 'Aplicacion/listarPorOffice';
  private asignarAplicacionRolUrl: string = 'aplicacionRole/insertar';
  private deleteAplicacionRolUrl: string = 'aplicacionRole/delete'
  private listarAplicacionPorAccesoUrl: string = 'aplicacion/listarPorAcceso';

  listarApplication(): any {
    this.dataService.set(this.listarApplicationUrl);
    return this.dataService.execGetJson();
  }

  toggleAplicacionRol(RoleID: number, AplicacionID: number, OfficeID: number, identificador: boolean) {
    let parameters: string;
    parameters = JSON.stringify({
      RoleID: RoleID,
      AplicacionID: AplicacionID,
      OfficeID: OfficeID,
    })
    if (identificador)
      this.dataService.set(this.asignarAplicacionRolUrl);
    else
      this.dataService.set(this.deleteAplicacionRolUrl);
    return this.dataService.execPostJson(parameters);
  }

  listarPorApplication(filtro: string, pageIndex: number, pageSize: number): any {
    let parameters = new HttpParams();
    parameters = parameters.append("pFiltro", String(filtro));
    parameters = parameters.append("pageIndex", String(pageIndex));
    parameters = parameters.append("pageSize", String(pageSize));
    this.dataService.set(this.listarPorApplicationUrl);
    return this.dataService.execGetJson(parameters);
  }

  // TODO: NO SE RELACIONA CON OTRAS FUNCIONALIDADES
  listarApplicationPorOffice(filtro: string, officeID: number, pageIndex: number, pageSize: number): any {
    let parameters = new HttpParams();
    parameters = parameters.append("pFiltro", String(filtro));
    parameters = parameters.append("pOfficeID", String(officeID));
    parameters = parameters.append("pageIndex", String(pageIndex));
    parameters = parameters.append("pageSize", String(pageSize));
    this.dataService.set(this.listarApplicationPorOfficeUrl);
    return this.dataService.execGetJson(parameters);
  }

  // TODO: NO SE RELACIONA CON OTRAS FUNCIONALIDADES
  listarAccessApplicacton(filtro: string, officeID: number, pageIndex: number, pageSize: number): any {
    let parameters = new HttpParams();
    parameters = parameters.append("pFiltro", String(filtro));
    parameters = parameters.append("pOfficeID", String(officeID));
    parameters = parameters.append("pageIndex", String(pageIndex));
    parameters = parameters.append("pageSize", String(pageSize));
    this.dataService.set(this.listarApplicationAccessUrl);
    return this.dataService.execGetJson(parameters);
  }

  obtenerApplication(applicationID: number): any {
    let parameters = new HttpParams();
    parameters = parameters.append("pKey", String(applicationID));

    this.dataService.set(this.obtenerApplicationUrl);
    return this.dataService.execGetJson(parameters);
  }

  insertarApplication(application: Iapplication): any {
    let parameters: string;
    parameters = JSON.stringify({
      Name: application.Name,
      Path: application.Path,
      Icono: application.Icono,
      description: application.Description,
      Status: application.Status,
      UserCreation: this.sessionInfo.getCodUsuario(),
    });

    this.dataService.set(this.insertarApplicationUrl);
    return this.dataService.execPostJson(parameters);
  }

  actualizarApplication(application: Iapplication): any {
    let parameters: string;
    parameters = JSON.stringify({
      ID: application.ID,
      Name: application.Name,
      Path: application.Path,
      Icono: application.Icono,
      description: application.Description,
      userlastupdate: this.sessionInfo.getCodUsuario(),
      status: application.Status,
    });

    this.dataService.set(this.actualizarApplicationUrl);
    return this.dataService.execPostJson(parameters);
  }

  listarAplicacionPorAcceso(idUsuario: number, idNivelAcceso: number, idEntidad: number, idRol: number): any {
    let parameters = new HttpParams();
    parameters = parameters.append("idUsuario", String(idUsuario));
    parameters = parameters.append("idNivelAcceso", String(idNivelAcceso));
    parameters = parameters.append("idEntidad", String(idEntidad));
    parameters = parameters.append("idRol", String(idRol));
    this.dataService.set(this.listarAplicacionPorAccesoUrl);
    return this.dataService.execGetJson(parameters);
  }
}